var _g, _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamaskError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_28910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3369 0L34.0873 19.6643L38.9686 8.07557L60.3369 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05922 0.0232239L23.3704 8.07701L28.0054 19.8177L2.05922 0.0232239ZM49.7732 41.8205L61.3752 42.044L57.3204 55.9897L43.1634 52.0435L49.7732 41.8205ZM12.5613 41.8205L19.1464 52.0435L5.0133 55.9899L0.983154 42.044L12.5613 41.8205Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3752 16.8271L27.8494 32.331L13.6617 31.6776L17.6974 25.5136L17.7485 25.4543L27.3752 16.8271ZM34.8126 16.6541L44.5862 25.4548L44.6369 25.5138L48.6726 31.6778L34.488 32.331L34.8126 16.6541ZM19.562 41.8655L27.3088 47.9765L18.3099 52.3752L19.562 41.8655ZM42.7742 41.8645L44.0003 52.3754L35.0264 47.976L42.7742 41.8645Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2245 47.4005L44.3308 51.8647L35.8602 55.9403L35.9481 53.2466L35.2245 47.4005ZM27.1076 47.4024L26.4125 53.2026L26.4696 55.9372L17.9791 51.8647L27.1076 47.4024Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.478 34.3546L26.8576 39.4178L18.756 37.0149L24.478 34.3546ZM37.8565 34.3551L43.6055 37.0149L35.4773 39.4171L37.8565 34.3551Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1812 41.8137L18.8717 52.7105L11.8525 42.052L20.1812 41.8137ZM42.1541 41.814L50.483 42.052L43.4375 52.711L42.1541 41.814ZM48.8776 31.0614L42.8162 37.3156L38.1428 35.1535L35.9053 39.9157L34.4386 31.7265L48.8776 31.0614ZM13.4541 31.0614L27.896 31.7265L26.4289 39.9157L24.191 35.1542L19.5424 37.3159L13.4541 31.0614Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0457 29.7779L19.9035 36.8233L20.141 43.7787L13.0457 29.7779ZM49.296 29.7653L42.1877 43.791L42.4554 36.8233L49.296 29.7653ZM27.5606 30.2071L27.8366 31.966L28.5187 36.3477L28.0802 49.8053L26.0071 38.9944L26.0064 38.8827L27.5606 30.2071ZM34.7705 30.1827L36.3288 38.8827L36.328 38.9944L34.2498 49.8324L34.1676 47.1215L33.8433 36.2678L34.7705 30.1827Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.065 36.5434L42.833 42.5865L35.5986 48.293L34.1361 47.2469L35.7754 38.6981L43.065 36.5434ZM19.2949 36.5434L26.5592 38.6981L28.1985 47.2469L26.7361 48.293L19.5014 42.586L19.2949 36.5434Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5948 50.5302L25.8505 54.9702L25.8113 53.0741L26.5858 52.3858H35.7462L36.5487 53.0717L36.4894 54.9663L45.6865 50.5413L41.2111 54.2855L35.7998 58.0483H26.5114L21.1036 54.27L16.5948 50.5302Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5616 46.8094L35.8702 47.7455L36.637 53.94L35.5273 52.9914H26.8108L25.722 53.9591L26.4638 47.746L27.7728 46.8094H34.5616Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.604 0.544342L61.755 10.1146L59.7871 19.7913L61.1884 20.8856L59.2922 22.3502L60.7174 23.4646L58.8303 25.2043L59.9888 26.0538L56.9142 29.6891L44.304 25.9718L44.1948 25.9125L35.1077 18.1517L58.604 0.544342ZM3.73083 0.544342L27.2273 18.1517L18.14 25.9125L18.0308 25.9718L5.42055 29.6891L2.34603 26.0538L3.50357 25.2051L1.61766 23.4646L3.03998 22.3514L1.11536 20.8827L2.56946 19.7876L0.579834 10.1151L3.73083 0.544342Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6873 25.1589L57.0485 29.0973L61.3894 42.6423H49.9372L42.0465 42.743L47.7851 31.4185L43.6873 25.1589ZM18.6475 25.1589L14.549 31.4185L20.2883 42.743L12.4012 42.6423H0.969604L5.28603 29.0976L18.6475 25.1589ZM39.623 8.01096L35.8858 18.2301L35.0927 32.0349L34.7892 36.3619L34.765 47.4155H27.5695L27.5461 36.3827L27.2417 32.0313L26.4483 18.2301L22.7116 8.01096H39.623Z",
    fill: "#F5841F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4203,
    cy: 46,
    r: 14,
    fill: "#DC4B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7537 41.3334L60.087 50.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7537 50.6667L60.087 41.3334",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_28910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.1751,
    height: 58.0645,
    fill: "white",
    transform: "translate(0.579834)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskError);
export default __webpack_public_path__ + "static/media/metamask-error.c9b4a53be6bd40e03ccc0068a5bd680c.svg";
export { ForwardRef as ReactComponent };